// ============================================================================
// ecgLabels.ts — подписи вердикта качества снимка ЭКГ (единая точка клиента).
//
// Анализатор отдаёт good / marginal / bad; ранние ответы — acceptable / warning /
// retake. Неизвестный вердикт показывается как есть (без выдуманной подписи).
// ============================================================================

export const ECG_QUALITY_VERDICT_LABELS: Record<string, string> = {
    good: 'Хорошее',
    marginal: 'Приемлемое',
    acceptable: 'Приемлемое',
    warning: 'С оговорками',
    retake: 'Требуется повтор',
    bad: 'Плохое',
};

export function ecgQualityVerdictLabel(verdict: string): string {
    if (!verdict) return '—';
    return ECG_QUALITY_VERDICT_LABELS[verdict] || verdict;
}
